import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

// crumbs: [{ label, path }]  — last item is current (no link)
export const Breadcrumbs = ({ crumbs = [], dark = false }) => {
  const items = [{ label: "Home", path: "/" }, ...crumbs];
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className={cn(
        "flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[11px] uppercase tracking-[0.16em]",
        dark ? "text-white/50" : "text-slatey"
      )}
    >
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={c.path + i} className="flex items-center gap-2">
            {last ? (
              <span className={dark ? "text-white" : "text-navy"}>{c.label}</span>
            ) : (
              <Link
                to={c.path}
                className={cn(
                  "transition-colors",
                  dark ? "hover:text-white" : "hover:text-electric"
                )}
              >
                {c.label}
              </Link>
            )}
            {!last && <ChevronRight className="h-3 w-3 opacity-50" />}
          </span>
        );
      })}
    </nav>
  );
};
